import Base from './base'
import { getImServiceAuth,toTalk,findTalkIndex,formatTalkUser} from '@/utils/imService';
import Vue from 'vue';
import router from "@/router";
/**
 * im聊天
 * sys_sign:类型
	 1 节假日
	 2 坐席忙碌
	 3 排队
	 4 主动满意度 4.1 自动满意度 
	 5 会话结束
	 6 坐席加入会话
	 7 坐席离开会话
	 8.1 收到转接请求 8.2 接收转接请求 8.3 拒绝转接请求
	 9 预览客人发送的消息 9.1 typing 9.2 endtyping 
	 13 文件上传成功
	 18 客人离开会话
	 20 会话自动关闭
	 21,22 客人关闭会话
 */
class Livechat extends Base {
	/**
	 * @var resource 资源
	 */
	resource
	session_id = ''
	sender_type = ''

	/**
	 * 初始化构造方法
	 *
	 * @param {Object} resource Socket消息
	 */
	constructor(resource) {
		super()
		this.session_id = resource.session_id
		this.resource = resource
		this.sender_type = resource.sender_type
	}
	/**
	 * 判断消息发送者是否来自于我
	 * @returns
	 */
	isCurrSender() {
	  return this.sender_type == 2
	}
	
	handle() {
		switch (this.resource.sys_sign){
			case '5':
				this.endTalkSession();
				break;
			case '8.1':
				this.getTransformRequest();
				break;
			case '8.2':
				this.acceptTransformRequest();
				break;
			case '8.3':
				this.refuseTransformRequest();
				break;
			case '9':
				this.getPreviewText();
				break;
			default:
				this.ininData();
				break;
		}
	}
	ininData(){
		this.getStoreInstance().commit('imChatService/UPDATE_PREVIEW_TEXT', '');//清除预览
		if(this.resource.sender_type == 2 && this.resource.sendStatus) return;
		this.getStoreInstance().commit('imChatService/PUSH_INDEXDB_RECORDS',this.resource)
		if(this.getStoreInstance().state.app.isShowTips) {
			this.createNotification();
		}
		// 判断当前是否在聊天页面
		if (!this.isTalkPage()) {
		 // 判断消息是否来自于我自己，否则会提示消息通知
		  !this.isCurrSender() && this.showMessageNocice()
		}
		// 判断会话列表是否存在，不存在则创建
		if (findTalkIndex(this.session_id) == -1) {
			return this.addTalkItem()
		}
		let isTrue = this.isTalk(this.resource);
		if(isTrue){
			 this.insertTalkRecord()
		}else {
			this.updateTalkItem()
		}
		
	}
	/*** 坐席预览（客人输入中文字）**/
	getPreviewText() {
		this.getStoreInstance().commit('imChatService/UPDATE_PREVIEW_TEXT', this.resource);
	}

	/* 收到转接请求*/
	getTransformRequest() {
		let results = JSON.parse(this.resource.msg);
		let params = {
			name: results?.fromName || '暂无昵称',
			session_id: results.session.sessionId,
			from: results.from,
			toBrand: results.toBrand,
			toSkillGroup: results.toSkillGroup,
			skillGroupName: results.session.skillGroupName
		};
		this.getStoreInstance().commit('imChatService/PUSH_TRANSFORM_VIEW',{
			show:true,
			item:params
		});
	}
	
	 /* 对方已接收转接请求*/
	 acceptTransformRequest(){
		 this.getStoreInstance().commit('imChatService/REMOVE_TALK_ITEM', this.session_id);
		 this.getStoreInstance().commit('imChatService/DELETE_CUSTOMERINFO_PANELS',this.session_id);
		 const index = this.resource.msg.indexOf('接收');
		 let tips = this.resource.msg;
		 if(index != -1) {
		 	tips = this.resource.msg.slice(0,index) + '转接了您的会话';
		 }
		 this.$notify({
			  message: tips,
			  type: 'success',
			  duration:10 * 1000
		 })
	 }
	 
	 /* 对方已拒绝转接请求*/
	 refuseTransformRequest(){
		 this.$notify({
			  message: this.resource.msg,
			  type: 'error',
			  duration:60 * 1000
		 })
	 }
	 
	/* 结束会话 */
	endTalkSession(){
		if (findTalkIndex(this.session_id) == -1) return;
		this.getStoreInstance().commit('imChatService/REMOVE_TALK_ITEM', this.session_id);
		this.getStoreInstance().commit('imChatService/DELETE_CUSTOMERINFO_PANELS',this.session_id);
		// if(getImServiceAuth('1008')){
		// 	Vue.prototype.$api.judgeImserviceToSaveCommunication(this.session_id).then(res => {
		// 		if(res.data){
		// 			 this.getStoreInstance().commit('imChatService/REMOVE_TALK_ITEM', this.session_id);
		// 			 this.getStoreInstance().commit('imChatService/DELETE_CUSTOMERINFO_PANELS',this.session_id);
		// 		}
		// 	})
		// }else {
		// 	this.getStoreInstance().commit('imChatService/REMOVE_TALK_ITEM', this.session_id);
		// 	this.getStoreInstance().commit('imChatService/DELETE_CUSTOMERINFO_PANELS',this.session_id);
		// }
	}
	
	/**
	 * 更新对话列表记录
	 */
	updateTalkItem() {
		if(this.resource.sys_sign != 6){
			if(this.sender_type != 1) return;
		}
		
		let obj = {
			 session_id: this.session_id,
			 sendtime: new Date().getTime(),
			 content:this.getTalkText(),
			 sender_type:this.sender_type
		}
	   let store = this.getStoreInstance()
	
	  store.commit('imChatService/UPDATE_TALK_MESSAGE', obj)
	}
	
	/**
	 * 插入对话记录
	 */
	insertTalkRecord(){
		let store = this.getStoreInstance();
		let record = this.resource;
		if(record.sender_type == 2){
			store.commit('imChatService/BATCH_DELETE_DIALOGUE', [record.msg_id]);
		}
		store.commit('imChatService/PUSH_DIALOGUE', record);
		// 获取聊天面板元素节点
		let el = document.getElementById('majorelChatPanel');
		let isBottom;
		if(el){
			isBottom = Math.ceil(el.scrollTop) + el.clientHeight >= el.scrollHeight;
		}
		// 判断的滚动条是否在底部
		
		if (isBottom || this.isCurrSender()) {
		  Vue.nextTick(() => {
		    el.scrollTop = el.scrollHeight
		  })
		} else {
		  store.commit('imChatService/SET_TLAK_UNREAD_MESSAGE', {
		    content: this.getTalkText(),
		    nickname: record.sender_type == 1 ? '客人' : '系统消息',
		  })
		}
		if(record.sender_type == 1){
			store.commit('imChatService/UPDATE_TALK_ITEM', {
			  session_id: record.session_id,
			  content: this.getTalkText(),
			  sendtime: new Date().getTime()
			})
		}
		
	}
	
	/**
	 * 加载对话节点
	 */
	async addTalkItem() {
	  let session_id = this.session_id;
	 await  Vue.prototype.$api.getImDialogueLists(session_id).then(res => {
		  if(res.errcode != 0) return;
		  if(findTalkIndex(this.session_id) == -1){
				this.getStoreInstance().commit('imChatService/PUSH_TALK_ITEM', formatTalkUser(res.data))
		  }
		  // if(this.resource.sender_type != 1) return;
		  this.updateTalkItem()
		
	  })
	}
	
	/* 展示信息提示 */
	showMessageNocice(){
		let content = this.getTalkText()
		let that = this;
		this.getStoreInstance().commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
			type:`IM进站消息网站内提示`,
			content:`当前坐席所在页面路径${router.history?.current?.path}`
		})
		this.$notify({
		  title: `IM聊天通知`,
		  message: `${content}`,
		  duration: 3 * 1000,
		  customClass: 'talk-notify pointer',
		  onClick: function() {
		    this.close()
		    toTalk(that.session_id);
			that.getStoreInstance().commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
				type:`坐席操作了IM进站消息网站内提示`,
			})
		  },
		  position: 'bottom-right',
		})
	}
	
	/* 消息类型 */
	getTalkText(){
		let text = this.resource.msg;
		switch(this.resource.type){
			case 'image':
				text = '【图片消息】'
				break;
			case 'file':
				text = '【文件消息】'
				break;
			case 'miniprogrampage':
				text ='【卡片消息】'
				break;
			case 'news':
				text ='【图文消息】'
				break;
			case 'voice':
				text ='【语音消息】'
				break;
			case 'video':
				text ='【视频消息】'
				break;
			
		}
		return text
	}
	
	/* 谷歌浏览器最小化提示 */
	createNotification(){
		let that = this;
		let store = this.getStoreInstance();
		if (!window.Notification) {
			console.log('!window.Notification')
			return false;
		}
		if (window.Notification.permission === 'granted') {
			that.NotificationSend();
		} else if (window.Notification.permission === 'default') {
			window.Notification.requestPermission().then(permission => {
				if (permission === 'granted') {
					console.log('用户同意授权');
					that.NotificationSend();
				} else if (permission === 'default') {
					store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
						type:`坐席关闭谷歌授权`,
					})
					console.warn('用户关闭授权 未刷新页面之前 可以再次请求授权');
				} else {
					console.log('用户拒绝授权 不能显示通知');
					store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
						type:`用户拒绝授权 不能显示谷歌通知`,
					})
				}
			});
		} else {
			console.log('用户曾经拒绝显示通知');
			store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
				type:`用户曾经拒绝显示谷歌通知`,
			})
		}
	}
	NotificationSend(){
		let that = this;
		let store = this.getStoreInstance();
		let instanceNotification = new Notification("您有1个新的IM消息，请及时处理！", { "icon": "https://assistant-cdn.porsche-scrm-engagement.com/static/images/logoIcon.png", "body": "快点击处理吧!" });
		instanceNotification.onshow = function () {
			console.log("显示通知");
			store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
				type:`谷歌通知显示`,
			})
		};
		instanceNotification.onclick = function () {
			window.focus();
			setTimeout(() => {
				 toTalk(that.session_id);
			}, 800);
			instanceNotification.close();
		};
		instanceNotification.onclose = function () {
			console.log("通知关闭");
			store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
				type:`用户主动关闭谷歌显示通知`,
			})
		};
		instanceNotification.onerror = function () {
			console.log('错误');
		};
	}

}

export default Livechat
